var fetchData = async (url, params, callback) => {
    const options = {
        method: 'GET',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'x-contact-id': params.contactId,
            'Original-Domain': params.shopDomain,
            
        }
    };

    try {
        const response = await fetch(url, options);
        const data = await response.json();
        callback && callback(data);
        return data;
    } catch (error) {
        throw new Error(`Failed fetch url: ${url}`);
    }
};

var renderEmarsysPointBalanceSideMenu = (data) => {
    const points = data.points;
    const sideMenuPointElements = document.querySelectorAll('.side_menu_body_point');
    sideMenuPointElements.forEach(element => {
        element.innerHTML = `${points.balance}  punti`;
    });
}

var renderEmarsysPointBalance = async (points, tier) => {
    const container = document.getElementById('balance-board');
    const cumulate_points = document.getElementById('balance-cumulate')
    cumulate_points.innerHTML = `${points.balance} <span>punti</span>`;

    if (tier) {
        renderTierSection(tier)
    }

    moment.locale(Shopify.locale);
    const selectors = createTabSelectors("balance-board-table", "tbody", "row");

    await resolveAfterDisplayPointsRows(container, points);
    await getPagination(selectors);

    const voucherFaq = document.querySelector('#loyalty-points ~ .product__faq');
    if (voucherFaq) {
        voucherFaq.style.display = 'none'
    }
    document.querySelector("#balance .balance-board.balance-board--hide").classList.remove("balance-board--hide");
    document.getElementById("emarsys-loyaltyPoints-loader").remove();
}

function resolveAfterDisplayPointsRows(container, points) {
    const fragment = document.createDocumentFragment();

    points.pointsAllocations.forEach((result, idx) => {
        const allocatedAtUnix = result.allocatedAt;
        const allocatedAt = moment.unix(allocatedAtUnix).format('L');

        

        const content = `
                            <div class="cell amount">${result.amount} punti</div>
                            <div class="cell allocated-at">${allocatedAt}</div>
                            <div class="cell activity">${result.pointsType}</div>
                            
                            
                        `;
        const div = document.createElement('div');
        div.classList.add('row', `row-${idx}`);
        div.innerHTML = content;
        fragment.appendChild(div);
    });

    container.innerHTML = '';
    container.appendChild(fragment);
}

var getVouchersContent = async (data) => {
    if (!Array.isArray(data) && (!data || !data.vouchers)) {
        throw new Error("Vouchers redeemed: Invalid data format");
    }

    const vouchers = await (Array.isArray(data) ? data : data.vouchers);
    const allVouchers = createTabSelectors("all", "voucher__list--all", "list__item", "pagination");
    const expirePage = createTabSelectors("expire-soon", "voucher__list--expire-soon", "list__item", "pagination");

    await resolveAfterRender(vouchers, allVouchers.listElement)
    await getPagination(allVouchers);

    const expireSoonVouchers = vouchers.filter(voucher => isVoucherExpireSoon(voucher.valid_until));

    await resolveAfterRender(expireSoonVouchers, expirePage.listElement)
    await getPagination(expirePage)
}

function createTabSelectors(id, listElement, listItem, pagination) {
    pagination = pagination ?? '' ? `#${id} .${pagination}` : '.pagination';

    return {
        id: `#${id}`,
        table: `#${id} .${listElement} .${listItem}`,
        listElement: `.${listElement}`,
        pagination: {
            pagination,
            next: `${pagination} #next`,
            prev: `${pagination} #prev`,
            li: `${pagination} li`
        }
    }
}

function resolveAfterRender(vouchers, element) {
    const listElement = document.querySelector(element);
    const fragment = document.createDocumentFragment();

    vouchers.forEach((voucher) => {
        const template = `
                <details class="voucher">
                    <summary class="voucher__summary">
                        <div class="voucher__coupon">
                            <img class="image" src="//shop.biotechusa.it/cdn/shop/t/6/assets/loyalty-coupon.png?v=183242433908567989231762781023" />
                            <span class="title">${voucher.voucher_category_name}</span>
                            <p>${voucher.coupon_value}</p>
                        </div>
                        <div class="voucher__details">
                            <div class="valid">
                                <span class="voucher__detail label">
                                    Valido fino a
                                </span>
                                <span class="voucher__detail date">
                                ${formattedUnixTime(voucher.valid_until)}
                                </span>
                            </div>

                            <img class="accordion__toggle" src="//shop.biotechusa.it/cdn/shop/t/6/assets/arrow_icon.svg?v=88198800164000211541601539213" alt="chevron">

                            <div class="updated">
                                <span class="voucher__detail label">
                                    Erogato il
                                </span>
                                <span class="voucher__detail date">${formattedUnixTime(voucher.voucher_bought_at)}</span>
                            </div>

                            ${isVoucherExpireSoon(voucher.valid_until)
            ? `<div class="is-redeemed expire-soon label">
                                   <img src="//shop.biotechusa.it/cdn/shop/t/6/assets/red-clock_small.svg?v=13221964969258443271693229526" alt="expire-soon" class="clock" /> Scadenza imminente
                                   </div>`
            : ''}

                        </div>
                    </summary>

                    <article class="voucher__description">
                        <div class="voucher-code__container">
                            <input class="voucher__code" id="voucher-code-${voucher.id}" type="text" value="${voucher.code}"/>
                            <button class="copy-code label" type="button" data-value="${voucher.code}">
                                Copia Codice
                             </button>
                        </div>

                        <p class="voucher__text">
                            ${voucher.voucher_text}
                        </p>
                    </article>
                </details>
            `;

        const li = document.createElement('li');
        li.classList.add('list__item', 'list__item--bordered', 'list__item--p0');
        li.innerHTML = template;
        fragment.appendChild(li)
    })

    listElement.innerHTML = '';
    listElement.appendChild(fragment);
}

function getPagination(selector) {
    $('#maxRows')
        .on('change', function (evt) {
            $(selector.pagination.pagination)
                .find('li')
                .slice(1, -1)
                .remove();
            let lastActivePage = 1;
            let trnum = 0;
            let maxRows = parseInt($(this).val());
            const totalRows = $(selector.table).length;
            const firstPage = 1;
            const lastPage = Math.ceil(totalRows / maxRows);

            if (totalRows < maxRows) {
                $(selector.pagination.pagination).hide();
            } else {
                $(selector.pagination.pagination).show();
            }

            $(selector.table).each(function () {
                trnum++;

                if (trnum > maxRows) {
                    $(this).removeClass('visible');
                }

                if (trnum <= maxRows) {
                    $(this).addClass('visible');
                }
            });

            if (totalRows > maxRows) {
                let pagenum = Math.ceil(totalRows / maxRows);

                for (let i = 1; i <= pagenum;) {
                    $(selector.pagination.next)
                        .before(`
                                <li data-page="${i}">
                                    <span>
                                        ${i++}<span class="sr-only">(current)</span>
                                    </span>
                                </li>
                                `)
                        .show();
                }
            }

            $(`${selector.pagination.pagination} [data-page="1"]`).addClass('active');
            $(selector.pagination.li).on('click', function (evt) {
                evt.stopImmediatePropagation();
                evt.preventDefault();
                document.querySelector(selector.id).scrollIntoView();

                let pageNum = $(this).attr('data-page');

                let maxRows = parseInt($('#maxRows').val());

                if (pageNum === 'prev') {
                    if (lastActivePage == 1) {
                        return;
                    }
                    pageNum = --lastActivePage;
                }

                if (pageNum === 'next') {
                    if (lastActivePage == $(selector.pagination.li).length - 2) {
                        return;
                    }
                    pageNum = ++lastActivePage;
                }

                if (firstPage == pageNum) {
                    $(selector.pagination.prev).css('visibility', 'hidden');
                } else {
                    $(selector.pagination.prev).css('visibility', 'visible');
                }

                if (lastPage == pageNum) {
                    $(selector.pagination.next).css('visibility', 'hidden');
                } else {
                    $(selector.pagination.next).css('visibility', 'visible');
                }

                lastActivePage = pageNum;

                let trIndex = 0;

                $(selector.pagination.li).removeClass('active');
                $(`${selector.pagination.pagination} [data-page="${lastActivePage}"]`).addClass('active');

                limitPagging(selector);

                $(selector.table).each(function () {
                    trIndex++;

                    if (trIndex > maxRows * pageNum || trIndex <= maxRows * pageNum - maxRows) {
                        $(this).removeClass('visible');
                    } else {
                        $(this).addClass('visible');
                    }
                });
            });
            limitPagging(selector);
        })
        .val(7)
        .change();
}

function limitPagging(selector) {
    if ($(selector.pagination.li).length > 7) {
        if ($(`${selector.pagination.pagination} li.active`).attr('data-page') <= 3) {
            $(`${selector.pagination.pagination} li:gt(5)`).hide();
            $(`${selector.pagination.pagination} li:lt(5)`).show();
            $(`${selector.pagination.pagination} [data-page="next"]`).show();
        }

        if ($(`${selector.pagination.pagination} li.active`).attr('data-page') > 3) {
            $(`${selector.pagination.pagination} li:gt(0)`).hide();
            $(`${selector.pagination.pagination} [data-page="next"]`).show();

            for (let i = (parseInt($(`${selector.pagination.pagination} li.active`)
                .attr('data-page')) - 2); i <= (parseInt($(`${selector.pagination.pagination} li.active`).attr('data-page')) + 2); i++) {
                $(`${selector.pagination.pagination} [data-page="${i}"]`).show();
            }
        }
    }
}

var renderEmarsysVouchers = async (data, loyaltyCustomVoucherDescriptions) => {
    const vouchers = data.vouchers;
    const new_data = {
        "vouchers": []
    };

    // Convert loyaltyCustomVoucherDescriptions to a map for easy lookup
    const couponDescriptionsMap = new Map();
    if (loyaltyCustomVoucherDescriptions) {
        loyaltyCustomVoucherDescriptions.forEach(desc => {
            const descText = desc.text.replace(/"/g, '&quot;');
            couponDescriptionsMap.set(desc.coupon_id, descText);
        });
    }

    // Group vouchers by category_title
    const categoryGroups = {};

    vouchers.forEach(voucher => {
        voucher.custom_text = couponDescriptionsMap.get(voucher.id) || '';

        if (!categoryGroups[voucher.category_title]) {
            categoryGroups[voucher.category_title] = [];
        }

        categoryGroups[voucher.category_title].push({
            id: voucher.id,
            category_title: voucher.category_title,
            point_amount: voucher.point_amount,
            voucher_category_name: voucher.voucher_category_name,
            link: voucher.link,
            text: voucher.text,
            custom_text: voucher.custom_text,
            voucher_title: voucher.voucher_title
        });
    });

    // Create the new_data structure
    for (const category_title in categoryGroups) {
        const elements = categoryGroups[category_title];
        const id = `voucher-${category_title}`;

        new_data.vouchers.push({
            id: id.toLowerCase().replace(/[^\w ]+/g, "").replace(/\s+/g, '-'),
            title: category_title,
            elements: elements
        });
    }

    const tab_ul_container = document.getElementById('redemption-tabs');
    const tab_content_container = document.getElementById('redemption-tabs-content');

    new_data.vouchers.forEach((result) => {
        const selectedId = result.id;

        const tab_ul_container_content = `
            <li class="tab-li">
                <a href="#${selectedId}" class="tab-li__link">
                    ${result.title}
                </a>
            </li>
          `;
        tab_ul_container.innerHTML += tab_ul_container_content;

        const tab_content_container_content = `
            <div id="${selectedId}" data-tab-content>
                <div id="redemption-cards" class="voucher-cards"></div>
            </div>
          `;
        tab_content_container.innerHTML += tab_content_container_content;

        result.elements.forEach((eResult, idx) => {
            const not_enough_point = notEnoughPoints(eResult.point_amount, "voucher-cards__card--not-enough-point");

            const container = document.querySelector(`#${selectedId} .voucher-cards`);

            const content = renderVouchersContent(idx, eResult, not_enough_point);

            container.innerHTML += content;
        })
    })

    const container = document.querySelector('#all .voucher-cards');

    vouchers.forEach((result, idx) => {
        const not_enough_point = notEnoughPoints(result.point_amount, "voucher-cards__card--not-enough-point");

        const content = renderVouchersContent(idx, result, not_enough_point);

        container.innerHTML += content;
    })
};

var tabSelect = (tabsElement, tabContentsElement) => {
    const tabs = document.querySelectorAll(tabsElement ?? '[data-tab-target]')
    const tabContents = document.querySelectorAll(tabContentsElement ?? '[data-tab-content]')

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const target = document.querySelector(tab.dataset.tabTarget)
            tabContents.forEach(tabContent => {
                tabContent.classList.remove('active')
            })
            tabs.forEach(tab => {
                tab.classList.remove('active')
            })
            tab.classList.add('active')
            target.classList.add('active')
        })
    })
};

var nestedTabSelect = (tabsElement, currentElement) => {
    const tabs = tabsElement ?? 'ul.tabs';
    const currentClass = currentElement ?? 'active';

    document.querySelectorAll(tabs).forEach(function (tabContainer) {
        let activeLink, activeContent;
        const links = Array.from(tabContainer.querySelectorAll("a"));

        activeLink =
            links.find(function (link) {
                return link.getAttribute("href") === location.hash;
            }) || links[0];
        activeLink.classList.add(currentClass);

        activeContent = document.querySelector(activeLink.getAttribute("href"));
        activeContent.classList.add(currentClass);

        links.forEach(function (link) {
            if (link !== activeLink) {
                const content = document.querySelector(link.getAttribute("href"));
                content.classList.remove(currentClass);
            }
        });

        tabContainer.addEventListener("click", function (e) {
            if (e.target.tagName === "A") {
                // Make the old tab inactive.
                activeLink.classList.remove(currentClass);
                activeContent.classList.remove(currentClass);

                // Update the variables with the new link and content.
                activeLink = e.target;
                activeContent = document.querySelector(activeLink.getAttribute("href"));

                // Make the tab active.
                activeLink.classList.add(currentClass);
                activeContent.classList.add(currentClass);

                e.preventDefault();
            }
        });
    });
};

var isVoucherExpireSoon = (validUntil) => {
    moment.locale(Shopify.locale)
    const now = moment().unix();
    const difference = Math.floor(validUntil / 1000) - now;
    const daysLeft = Math.floor(difference / 60 / 60 / 24);

    return daysLeft < 30
}

var formattedUnixTime = unixTimeStamp => {
    moment.locale(Shopify.locale)
    return moment(unixTimeStamp).format('LL');
}

function copyCode() {
    const code = $(this).attr('data-value');
    navigator.clipboard.writeText(code)
}

document.addEventListener('DOMContentLoaded', () => {
    /* Voucher Modal START */
    const profile_selectors = {
        right: 'profile_page_grid_right',
        left: 'profile_page_grid_left',
        header: 'account_page_header'
    }
    const voucher_remodal = {
        container: '[data-remodal-id=voucher-details-modal] .voucher-remodal__container',
        container_class: 'voucher-remodal__container--not-enough-point'
    };

    function hideProfileSelectors() {
        Object.values(profile_selectors).forEach(selector => {
            const element = document.getElementById(selector);
            if (element) {
                element.style.display = 'none';
            }
        });
    }

    function showProfileSelectors() {
        Object.values(profile_selectors).forEach(selector => {
            const element = document.getElementById(selector);
            if (element) {
                element.removeAttribute('style');
            }
        });
    }

    $(document).on("click touch", "#voucher-button", function (e) {
        e.preventDefault();
        const voucher = {
            title: $(this).attr("data-category-title"),
            name: $(this).attr("data-category-name"),
            points: parseInt($(this).attr("data-points"), 10),
            desc: $(this).attr("data-description"),
            customDesc: $(this).attr("data-custom-description"),
            id: $(this).attr("data-voucher-id"),
            voucher_title: $(this).attr("data-voucher-title")
        };
        const not_enough_point = notEnoughPoints(voucher.points, voucher_remodal.container_class);
        hideProfileSelectors();
        document.querySelector("body").scrollIntoView();

        if (0 === document.querySelectorAll('[data-remodal-id=voucher-details-modal]').length) {
            $('body #loyalty-points').prepend(voucherDetailsModal('voucher-details-modal', not_enough_point));
        }

        if (not_enough_point.class !== '') {
            document.querySelector(voucher_remodal.container).classList.add(voucher_remodal.container_class);
        }

        const container = document.querySelector(voucher_remodal.container);
        container.innerHTML = voucherDetailsContent(voucher, not_enough_point);

        document.querySelector('main').classList.add('wrapper--voucher');
        document.querySelector('[data-modal-id=voucher-details-modal]').style.display = 'block';
        const voucherFaq = document.querySelector('#loyalty-points ~ .product__faq');
        if (voucherFaq) {
            voucherFaq.style.display = 'block'
        }
        document.querySelector('[data-remodal-id=voucher-details-modal]').style.display = 'inline-block';
    });

    $(document).on("click touch", "#voucher-close-button", function (e) {
        e.preventDefault();

        showProfileSelectors();
        document.querySelector('main').classList.remove('wrapper--voucher');
        document.querySelector(voucher_remodal.container).classList.remove(voucher_remodal.container_class);
        document.querySelector('[data-modal-id=voucher-details-modal]').style.display = 'none';
        const voucherFaq = document.querySelector('#loyalty-points ~ .product__faq');
        if (voucherFaq) {
            voucherFaq.style.display = 'none'
        }
        document.querySelector('[data-remodal-id=voucher-details-modal]').style.display = 'none';
    });

    $(document).on("click touch", "#voucher-redemption-button", function (e) {
        e.preventDefault();
        const voucher = {
            title: $(this).attr("data-category-title"),
            name: $(this).attr("data-category-name"),
            points: parseInt($(this).attr("data-points"), 10),
            id: $(this).attr("data-voucher-id"),
            redemption: 'Vuoi utilizzare &lt;span class=&quot;highlited&quot;&gt;!!#points#!! punti&lt;/span&gt; per il voucher !!#title#!!?',
            points_remains: 'Dopo questo, avrai ancora &lt;span class=&quot;highlited-blue&quot;&gt;!!#points_remains#!! punti&lt;/span&gt; disponibili.'
        };

        const not_enough_point = notEnoughPoints(voucher.points, voucher_remodal.container_class);
        const voucher_points_remains = Math.floor(emarsys_loyalty_points.points.balance - voucher.points);

        if (0 === document.querySelectorAll('[data-remodal-id=voucher-redeem-modal]').length) {
            $('body').prepend(voucherModal('voucher-redeem-modal'));
        }

        const container = document.querySelector('[data-remodal-id=voucher-redeem-modal] .voucher-remodal__container');
        container.innerHTML = voucherRedeem(voucher, not_enough_point);

        voucher.redemption = voucher.redemption
            .replace(/!!#points#!!/g, voucher.points)
            .replace(/!!#title#!!/g, voucher.name);
        voucher.redemption = $.parseHTML(voucher.redemption)[0]['data'];

        voucher.points_remains = voucher.points_remains
            .replace(/!!#points_remains#!!/g, voucher_points_remains);
        voucher.points_remains = $.parseHTML(voucher.points_remains)[0]['data'];

        const remodal_content = document.querySelector('#voucher-remodal-content-inner');
        remodal_content.innerHTML = `<p>${voucher.redemption}</p><p>${voucher.points_remains}</p>`;

        const options = {modifier: "biotech_modal-wrapper--voucher"}
        const inst = $('[data-remodal-id=voucher-redeem-modal]').remodal(options);
        inst.open();
    });

    $(document).on('closing', '.biotech_modal--voucher.success-voucher-redeem', function (e) {
        window.location.replace(`/pages/lealta-coupon`);
    });
});

/* Pontok bevaltasa, kupon vetel START */
var getEmarsysLoyaltyVoucher = (event) => {
    if (event.target.matches("#emarsys-redeem-voucher #submit-form")) {
        const emarsys_redeem_form = document.getElementById('emarsys-redeem-voucher');

        function submitHandler(event) {
            event.preventDefault();
            const submitButton = document.getElementById("submit-form");
            const xVoucherId = document.getElementById("x-voucher-id").value;
            const headersRedeemVoucher = {
                'X-Contact-Id': loyalty_contact_id,
                "X-Contact-Email": customer_email,
                "x-voucher-id": `${encodeURIComponent(xVoucherId)}`,
                'Original-Domain': shop_domain,
                "Accept": "application/json",
                
            }
            submitButton.setAttribute("disabled", "disabled");


            fetch(`${emarsys_loyalty_url}/redeemvoucher`, {
                method: "GET",
                headers: headersRedeemVoucher
            })
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw new Error(`${response.status}`);
                    }
                })
                .then(data => {
                    document.querySelector('.biotech_modal--voucher').classList.add('success-voucher-redeem');
                    const container = document.querySelector('[data-remodal-id=voucher-redeem-modal] .voucher-remodal__container');
                    container.innerHTML = voucherRedeemSuccess(data);
                })
                .catch(error => {
                    const status = Number(error.message);
                    window.Sentry && Sentry.captureMessage('Emarsys kupon beváltás sikertelen', {
                        level: status >= 400 && status < 500 ? 'warning' : 'error',
                        tags: { component: 'emarsys-voucher' },
                        extra: { error: String(error) }
                    });
                    document.getElementById('emarsys-redeem-voucher').innerHTML += `<div class="voucher-redeem-error">Si è verificato un errore imprevisto, riprova più tardi! <span>(${error})</span></div>`;
                    // Unregister the current submit handler
                    document.removeEventListener('submit', submitHandler);
                });
        }

        if (emarsys_redeem_form !== null) {
            emarsys_redeem_form.addEventListener('submit', submitHandler);
        }
    }
};

const notEnoughPoints = (point_amount, selector) => {
    const balance = emarsys_loyalty_points.points.balance;
    const not_enough_point = {
        class: balance < point_amount ? selector : '',
        missing: balance < point_amount ? Math.floor(point_amount - balance) : ''
    };
    return not_enough_point;
};

/* Voucher renderVouchers START */
const renderVouchersContent = (idx, data, not_enough_point) => {
    const voucher_title = data?.voucher_title ?? '';
    return `<div id="voucher-cards-${idx}" class="voucher-cards__card ${not_enough_point.class}">
                <div class="voucher__header">
                    <div class="voucher__detail background"></div>
                    ${not_enough_point.missing !== '' ? `<span class="voucher__detail points-missing">${not_enough_point.missing} punti mancanti</span>` : ``}
                    <div class="voucher-detail-container">
                            <span class="voucher__detail category-title">${data.category_title}</span>
                            <span class="voucher__detail points">${data.point_amount}</span>
                            <span class="voucher__detail points-text">punti</span>
                    </div>
                </div>
                <div class="voucher__content">
                    ${voucher_title}
                </div>
                <div class="voucher__footer">
                    <button id="voucher-button" class="voucher__button"
                        data-category-title="${data.category_title}"
                        data-category-name="${data.voucher_category_name}"
                        data-points="${data.point_amount}"
                        data-btn-text="Utilizza"
                        data-description="${data.text}"
                        data-custom-description="${data.custom_text}"
                        data-voucher-id="${data.id}"
                        data-voucher-title="${voucher_title}">
                            Dettagli
                    </button>
                </div>
            </div>`
}

/* Voucher details modal templates START */
const voucherDetailsModal = (modal_id, not_enough_point) => {
    return `<div class="biotech_modal-wrapper" data-modal-id="${modal_id}">
                    <div class="biotech_modal overlay-popup popup-stack" data-remodal-id="${modal_id}"
                        style="overflow-y:auto;overflow-x:auto;height:auto;min-height:100%;">
                        <button id="voucher-close-button" class="voucher-remodal__close-button"><span>Indietro</span></button>
                        <div class="voucher-remodal__container ${not_enough_point.class}"></div>
                    </div>
            </div>`;
}

const voucherDetailsContent = (voucher, not_enough_point) => {
    return `<div class="voucher-remodal__header">
                    <div class="voucher-remodal__detail background"></div>
                    ${not_enough_point.missing !== '' ? `<span class="voucher-remodal__detail points-missing">${not_enough_point.missing} punti mancanti</span>` : ``}
                    <div class="voucher-remodal-detail-container">
                            <span class="voucher-remodal__detail category-title">${voucher.title}</span>
                            <span class="voucher-remodal__detail name">${voucher.voucher_title}</span>
                            <span class="voucher-remodal__detail points-text">${voucher.points} punti</span>
                    </div>
                </div>
                <div class="voucher-remodal__content">
                    <div class="voucher-remodal__content-action">
                        <button id="voucher-redemption-button"
                        data-points="${voucher.points}"
                        data-category-title="${voucher.title}"
                        data-category-name="${voucher.voucher_title}"
                        data-voucher-id="${voucher.id}"
                        ${not_enough_point.missing !== '' ? `disabled` : ``}>
                            Utilizza
                        </button>
                        ${not_enough_point.missing !== '' ? `<p class="voucher-remodal__content-points-missing">
                            Non hai abbastanza punti per utilizzare
                        </p>` : ``}
                    </div>
                    <div class="voucher-remodal__content-inner">
                        <p>${voucher.desc}</p>
                        ${voucher.customDesc !== '' ? `<p>${voucher.customDesc}</p>` : ``}
                    </div>
                </div>
                <div class="voucher-remodal__footer"></div>`;
}

/* Voucher redeem modal templates START */
const voucherModal = (modal_id) => {
    return `<div class="biotech_modal biotech_modal--voucher overlay-popup popup-stack" data-remodal-id="${modal_id}" style="overflow-y:auto;overflow-x:auto;height:auto;max-height:544px;min-height:320px;">
                    <div class="voucher-remodal__container"></div>
                </div>
            </div>`;
}

const voucherRedeem = (voucher, not_enough_point) => {
    return `<div class="voucher-remodal__header">
                <h2 class="voucher-remodal__header--title">
                    Sei sicuro di voler utilizzare?
                </h2>
            </div>
            <div class="voucher-remodal__content">
                <div id="voucher-remodal-content-inner" class="voucher-remodal__content-inner"></div>
            </div>
            <div class="voucher-remodal__footer">
                <form id="emarsys-redeem-voucher" class="needs-validation" method="post">
                    <input type="hidden" id="x-voucher-id" name="x-voucher-id" value="${voucher.id}">

                    <button id="submit-form" class="voucher-redeem-button" type="submit" ${not_enough_point.missing !== '' ? `disabled` : ``}>
                        Utilizza
                    </button>
                </form>

                <button data-remodal-action="close" class="voucher-redeem-close-button">
                    Annulla
                </button>
            </div>`;
}

const voucherRedeemSuccess = (data) => {
    return `<div class="voucher-remodal__header">
                <img src="//shop.biotechusa.it/cdn/shop/t/6/assets/emarsys-voucher-success.png?v=102769031529730243751762780916" alt="BioTech USA"  width="48" height="48">
                <h2 class="voucher-remodal__header--title">
                    Successo
                </h2>
            </div>
            <div class="voucher-remodal__content">
                <div class="voucher-remodal__content-inner">
                    ${data && data.roadshow === true ? `
                    <p>Translation missing: it.loyalty_program.emarsys.points_page.redemption_modals.roadshow_succeeded_desc</p>` : `
                    <p>Ora puoi utilizzare il tuo voucher sconto sul negozio online o in uno dei nostri negozi!</p>`}
                </div>
            </div>
            <div class="voucher-remodal__footer">
                ${data && data.roadshow !== true ? `
                <input class="voucher__code" id="voucher-code-${data.code}" type="text" value="${data.code}" readonly/>
                <button id="emarsys-copy-code" class="voucher-copy-code-button" type="button" data-value="${data.code}">
                    Copia Codice
                </button>` : ``}

                <button class="voucher-redeem-close-button" type="button" onclick="location.href='/collections/all'">
                    Continua allo Shop Online
                </button>
            </div>`;
}

const renderTierSection = (tierData) => {
    const { currentPercent, currentTierName, nextTierName, pointsToNextTier } = tierData;
    const tierRootEl = document.querySelector('#tier');
    const amountToNext = `${Shopify.formatMoney(pointsToNextTier * 100) }`;
    const translation = `Acquista ancora per <span class="tier-info__value">{amount}</span> per raggiungere il {next} tier!`;
    const infoText = translation.replace('{next}', nextTierName).replace('{amount}', amountToNext);

    tierRootEl.innerHTML= `
        <div class="tier-badge ${currentTierName.toLowerCase()}"></div>
        <span class="tier-title">${currentTierName} tier</span>
        <div class="tier-progress">
          <div class="tier-progress__bar" style="width: ${currentPercent}%"></div>
        </div>
        <span class="tier-info">${infoText}</span>
        <a class="button--outlined tier-button" href="https://shop.biotechusa.it/pages/programma-fedelta-biotechusa">
            Maggiori informazioni
        </a>`;

    tierRootEl.classList.remove('hide');
}